"use client";
import React from "react";
import { motion } from "framer-motion";
import MapComponent from "../../components/map_component";
import {globalTransition} from  "../../assets/animate/globalAnimation"

const services = [
  "Expert Support & Quality Products",
  "Hydraulic Services",
  "Wide Product Range",
  "Top Brands Available",
  "PTS Tagging",
  "24/7 Emergency Service",
  "Rewards Program",
  "Factory-Trained Experts",
];

const Location: React.FC = () => {
  return (
    <div className="bg-[#2D3748] text-white relative py-20 lg:px-36 md:px-20">
          {/* Gradient Overlay */}
          <div className="absolute left-0 right-0 bg-gradient-to-t -top-28 w-full min-h-28 z-20 from-[#2D3748] to-transparent"></div>

      <div className="grid grid-cols-2 items-center">
        {/* Left - Map & Heading */}
        <motion.div
          className="col-span-2 lg:col-span-1 w-full flex flex-col justify-center"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ ...globalTransition, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <h2 className="text-lg md:text-2xl text-start w-full px-3 lg:pr-7 font-semibold leading-snug mb-6">
            Your Local One-Stop-Shop for Premier Products and Support
          </h2>
          {/* <img
            src="/assets/image/parker-map.png"
            alt="Location Map"
            className="rounded-lg shadow-xl lg:px-3 w-full max-w-md"
          /> */}
          <div className="px-5">
          <MapComponent/>
          </div>
          
        </motion.div>

        {/* Right - Features List */}
        <motion.div
          className="col-span-2 p-10 lg:col-span-1 space-y-6"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ ...globalTransition, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="flex items-center space-x-6"
              initial={{ opacity: 0, x: 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              {/* Gradient Number Circle */}
              <div className="relative flex items-center justify-center text-lg w-12 h-12 max-w-12 max-h-12 rounded-full font-bold bg-[#2D3748]">
                {/* Gradient Border */}
                <div className="absolute inset-0 rounded-full p-[0.5px] bg-gradient-to-t from-gray-600 to-gray-400">
                  <div className="h-full w-full bg-[#2D3748] rounded-full"></div>
                </div>

                {/* Number */}
                <span className="relative z-10">{index + 1}</span>
              </div>
              <p className="text-sm lg:text-lg font-medium tracking-wide">{service}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default Location;
